import { UserType } from '@repo/shared/types';
import { type LoaderFunctionArgs, redirect } from 'react-router';
import { AuthenticatedLayout } from '@/components/layout/authenticated';
import { getServerOrganizationSession, getSession } from '@/lib/auth-req';

const loader = async ({ request }: LoaderFunctionArgs) => {
  const pathname = new URL(request.url).pathname;
  const segments = pathname.split('/').filter(Boolean);
  const isBareOrganizationRoot = segments.length === 1 && segments[0] === 'o';

  if (!isBareOrganizationRoot) {
    return null;
  }

  const session = await getSession(request);
  if (!session.isAuthenticated || !session.user) {
    return redirect('/auth/signin');
  }

  if (session.user.type === UserType.ADMIN) {
    return redirect('/admin/organizations');
  }

  const organizations = await getServerOrganizationSession(request);
  if (!organizations?.length) {
    return redirect('/');
  }

  const first = organizations[0];
  if (!first) {
    return redirect('/');
  }
  return redirect(`/o/${first.id}/reports`);
};

export { loader as organizationLoader };
export type OrganizationLoader = Awaited<ReturnType<typeof loader>>;
export const OrganizationLayout = AuthenticatedLayout;
